module.exports = __webpack_public_path__ + "static/media/YB5F05_2.2efe9da0.jpg";